import React from 'react';
import {Address} from './address.js';

export class PersonContact extends React.Component {
    constructor(props){
        super(props);
    }

    render() {        
        return (
            <div className = 'dealer'>
                <div className="dealer-info">
                    {this.props.body.Image !== null ?
                        <div className="image">
                            <img src={this.props.body.Image} className="rounded lazy" alt=""/>
                        </div>
                    : ''}
                    <div className="text">
                        <h3>{this.props.body.Name}</h3>
                        <p className="info">{this.props.body.Title}</p>
                        <p>{this.props.body.Area}</p>
                        {this.props.body.MobilePhone !== null ?
                                <p className="contact-link" itemProp="telephone">            
                                    <a href={"tel:" + this.props.body.MobilePhone} className="phone">
                                        <span className="icon-mobile"></span>
                                        {this.props.body.MobilePhone}
                                    </a>
                                </p>
                            :''}
                        {this.props.body.Phone !== null ? 
                                    <p className="contact-link" itemProp="telephone">
                                        <a href={"tel:" + this.props.body.Phone} className="phone">
                                            <span className="icon-phone"></span>
                                            {this.props.body.Phone}
                                        </a>
                                    </p>
                                :''}
                        <p className="contact-link" itemProp="email"><a href={"mailto:" + this.props.body.Email} className="email">{this.props.body.Email}</a></p>
                        <Address    isUK = {this.props.body.IsUnitedKingdomDealer} //bör denna kollen vara i Address eller utanför?
                                    isPerson={this.props.isPerson}
                                    country = {this.props.body.Country}
                                    county = {this.props.body.County}
                                    zipcode = {this.props.body.ZipCode}
                                    street = {this.props.body.Street}
                                    city = {this.props.body.City}
                                    town = {this.props.body.Town}/>
                        <p>{this.props.body.OtherInformation}</p>
                    </div>
                </div>
            </div>
        );           
    } 
}